import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getSettlementConfig = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/settlement-config/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Settlement config fetch error:", error);
    throw error;
  }
};

const updateSettlementConfig = async (data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/settlement-config/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Settlement config update error:", error);
    throw error;
  }
};

export { getSettlementConfig, updateSettlementConfig };
